import { render, staticRenderFns } from "./galleryRecycleBin.vue?vue&type=template&id=5c66b5fc&scoped=true"
import script from "./galleryRecycleBin.vue?vue&type=script&lang=js"
export * from "./galleryRecycleBin.vue?vue&type=script&lang=js"
import style0 from "./galleryRecycleBin.vue?vue&type=style&index=0&id=5c66b5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66b5fc",
  null
  
)

export default component.exports